/* eslint-env node */
module.exports = {
  colors: {
    // Theme
    primary: '#111178',
    secondary: '#FACE3C',
    header: '#B8DE6F',
    // Text
    white: '#FFFFFF',
    black: '#000000',
    light: '#F2F2F3',
    muted: '#37374B',
    dark: 'rgba(6, 6, 30, 1)',
    // UI Elements
    positive: '#A4D534',
    neutral: '#F39032',
    negative: '#FA3C80',
    positive_light: '#BFE8C9',
    negative_light: '#FEC5E4',
    // System
    info: '#FACE3C',
    success: '#A4D534',
    error: '#FA3C80',
    warning: '#E89806',
    // Other
    transparent: 'transparent',
    feedback: '#04BFAD',
    //Student Statuses
    superstar: '#E95701',
    master: '#85C619',
    pro: '#7E29CC',
    apprentice: '#4A8DC9',
    rookie: '#91DEE1',
    table_border: 'rgba(0, 47, 100, 0.3)',
    // Gender
    male: '#0BBBEF',
    female: '#FFCD18',
    other: '#8A126E',
    // Year Group
    year1: '#F15025',
    year2: '#05F09D',
    year3: '#111178',
    year4: '#E2A0FF',
    year5: '#000000',
    year6: '#EF233C',
    year7: '#04BFAD',
    year8: '#F39032',
    year9: '#F0E2F3',
    year10: '#1C7C54',
    year11: '#FE547B',
    foundation: '#AFBBF2',
    preschool: '#6B0F1A',
    year_none: '#A3A1A1',
    //Extra Color Picker colors
    color15: '#6EF9F5',
    color16: '#F1E189',
    color17: '#292E1E',
    color18: '#E8998D',
    color19: '#57B8FF',
    color20: '#B8DE6F',
    currentColor: 'currentColor',
  },
  typography: {
    body: '"Nunito Sans",sans-serif',
  },
  sizes: {
    sm: '30px',
    md: '45px',
    lg: '55px',
  },
  fonts: {
    sm: '0.95rem',
    md: '1rem',
    lg: '1.25rem',
  },
  shadows: {
    sm: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  },
  radius: {
    default: '8px',
    input: '8px',
    button: '4px',
    circle: '999px',
  },
};
